module.exports = __webpack_public_path__ + "media/images/common/small_off-e1dc61bade87c0663fc7ca757a2a4053.gif";